export const DEX_WALLET_WIDGET_TYPE_ID = 'DexWalletWidget';
